/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import guidebookContentStyle from "../guidebookContentStyle";
import TextContainer from "../../Container/TextContainer";
import Layout from "../../../containers/Layouts/Layout";
import TeaserSlogan from "../../Teaser/TeaserSlogan";
import QuestionsContactSection from "../QuestionsContactSection/QuestionsContactSection";
import DoubleButton from "../../Button/DoubleButton";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router";
import backgroundTeaser from "../../../assets/img/guidebook/Teaser_streitige-Scheidung_700px.jpg";
import Typography from "@mui/material/Typography";
import { Link as MuiLink, Paper } from "@mui/material";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";
import { gaSet } from "../../../services/googleAnalyticsService";

const GuidebookContentiousDivorce = () => {
  const title = "Ratgeber - Streitige Scheidung | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"serviceworld"}>
      <Helmet>
        <title>{title}</title>
        <meta
          name="description"
          content="Sie haben bei Ihrer Scheidung und damit zusammenhängender Themen Streitigkeiten mit Ihrem Ex-Partner und können
            sich daher nicht einigen?"
        />
      </Helmet>

      <Paper sx={guidebookContentStyle.paper}>
        <TeaserSlogan
          slogan={"Einfach erklärt: Streitige Scheidung"}
          backgroundImagePath={backgroundTeaser}
          height={300}
          headingColor={"#333333"}
        />
        <TextContainer>
          <p>
            Sie haben bei Ihrer Scheidung und damit zusammenhängender Themen Streitigkeiten mit Ihrem Ex-Partner und können sich daher nicht einigen? Hier
            finden Sie kurz zusammengefasst Informationen zur streitigen (manchmal auch: strittigen) Scheidung.
          </p>
          <hr />
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Was ist eine streitige Scheidung?
          </Typography>
          <p>
            Wenn sich die Ehepartner bezüglich der Scheidung allgemein, oder zu Themen wie dem Unterhalt oder Sorgerecht nicht einigen können, handelt es sich
            um eine sogenannte streitige Scheidung. In diesem Fall ist es wichtig, dem Gericht die Scheidungsgründe und Streitpunkte mitzuteilen und ggf. auch
            zu beweisen, wenn der Ehepartner diese abstreitet. Bei einer streitigen Scheidung brauchen beide Ehepartner einen Anwalt, damit Ihre Ansichten
            vertreten werden können, und es kann zu einem langwierigen Prozess kommen.
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Was sind mögliche Streitpunkte?
          </Typography>
          <p>
            Bei einer Scheidung müssen sich die Ehepartner bezüglich der sogenannten Scheidungsfolgesachen einigen. Für Scheidungsfolgesachen ist im Normalfall
            keine Klärung vor Gericht nötig, wenn Sie sich die Partner einig werden. Wenn Sie sich bei bestimmten Folgesachen nicht einigen können, muss die
            Klärung vor Gericht stattfinden und die Scheidung wird von einer einvernehmlichen zu einer streitigen Scheidung.
          </p>
          <Typography sx={guidebookContentStyle.listIntroText}>
            Folgende Punkte (Scheidungsfolgesachen) müssen bei einer Scheidung geklärt werden und sind somit oft Streitpunkte zwischen den Ex-Partnern:
          </Typography>
          <MuiListNativeStyled
            sx={guidebookContentStyle.bulletList}
            listItems={["Ehegattenunterhalt", "Verteilung von Besitz/Hausrat und ehelicher Wohnung"]}
          />
          <Typography sx={guidebookContentStyle.listIntroText}>Wenn Sie gemeinsame, minderjährige Kinder haben, muss zusätzlich geklärt werden:</Typography>
          <MuiListNativeStyled sx={guidebookContentStyle.bulletList} listItems={["Sorgerecht", "Umgangsrecht", "Kindesunterhalt"]} />
          <p>
            Tipp: Sie finden im{" "}
            <MuiLink component={Link} sx={guidebookContentStyle.link} to={"/ratgeber/familienrecht"}>
              Ratgeber
            </MuiLink>{" "}
            zu all diesen Themen detaillierte Spezial-Artikel!
          </p>
          <Typography variant={"h4"} sx={guidebookContentStyle.subheader}>
            Ihre Scheidung
          </Typography>
          <p>
            Sie sind sich nicht sicher, ob es sich bei Ihnen um eine einvernehmliche oder eine streitige Scheidung handelt, möchten aber jetzt mit Ihrer
            Scheidung beginnen? Sie können ganz einfach alle Angaben für den Antrag direkt hier online eingeben und wir begleiten Sie professionell und sicher
            bei allen Schritten bis zu Ihrer Scheidung - egal ob einvernehmlich oder streitig.
          </p>
          <DoubleButton buttonText={"zum Scheidungsantrag"} buttonLink={"/servicewelt"} backText={"Zurück zum Ratgeber"} backLink={"/ratgeber/familienrecht"} />
          <QuestionsContactSection />
        </TextContainer>
      </Paper>
    </Layout>
  );
};

export default GuidebookContentiousDivorce;
